import Vue from 'vue';

const getCompanyIndex = (slug, state) => state.companies.findIndex(company => company.slug === slug);

export function setCompanies(state, items) {
   state.companies = items;
}

export function setFetching(state, fetching) {
   state.fetching = fetching;
}

export function replaceCompany(state, company) {
   const idx = getCompanyIndex(company.slug, state);
   if (idx >= 0) {
      state.companies.splice(idx, 1, company);
   }
}

export function setUpdatingCompany(state, { slug, updating }) {
   const idx = state.updating.indexOf(slug);
   if (updating && idx === -1) {
      state.updating.push(slug);
   } else if (!updating && idx >= 0) {
      state.updating.splice(idx, 1);
   }
}

export function setUpdatingPriorities(state, { slug, updating }) {
   const idx = state.priorities_updating.indexOf(slug);
   if (updating && idx === -1) {
      state.priorities_updating.push(slug);
   } else if (!updating && idx >= 0) {
      state.priorities_updating.splice(idx, 1);
   }
}

export function setUpdatingCapacities(state, { slug, updating }) {
   const idx = state.capacities_updating.indexOf(slug);
   if (updating && idx === -1) {
      state.capacities_updating.push(slug);
   } else if (!updating && idx >= 0) {
      state.capacities_updating.splice(idx, 1);
   }
}

export function replaceCapacities(state, { slug, capacities }) {
   const idx = getCompanyIndex(slug, state);
   if (idx >= 0) {
      Vue.set(state.companies[idx], 'capacities', capacities);
   }
}

export function setPriorityDefinitions(state, definitions) {
   state.priority_definitions = definitions;
}

export function replacePriorities(state, { slug, priorities }) {
   const idx = getCompanyIndex(slug, state);
   if (idx >= 0) {
      Vue.set(state.companies[idx], 'dynamic_priorities', priorities);
   }
}

export function setLoaded(state, loaded) {
   state.loaded = loaded;
}
